import { render, staticRenderFns } from "./Toservicer.vue?vue&type=template&id=d7ca7788&"
import script from "./Toservicer.vue?vue&type=script&lang=ts&"
export * from "./Toservicer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports